<script setup lang="ts">
  import { ref, onMounted, inject, toRefs, onUnmounted } from 'vue'
  import { useUserStore } from '@zaohaowu/website-common/stores/userStore'
  import getUserInfo from '@/utils/getUserInfo'
  import _fetch from '@/utils/fetch'
  import LoginService from '@zaohaowu/website-common/components/AppLogin/login'
  import TechManagePSW from '@/views/AppEduPages/components/TechManagePSW/TechManagePSW.vue'
  import trackUtil from '@/track/edulogin'
  import messageQueue from '@/utils/messageQueue'
  import { EventBusKey } from '@/utils/eventBusMitt'
  import emitter from '@/utils/eventBusMitt'
  import { useRouter } from 'vue-router'

  interface HeaderProps {
    headerTransparent?: boolean // 是否透明
    showCreateEntry?: boolean // 是否显示创建入口
  }

  const props = defineProps<HeaderProps>()
  const { headerTransparent, showCreateEntry } = toRefs(props)
  const ShowManagePSW = ref(false)
  const isShowBackBtn = ref(false)
  const router = useRouter()
  const $clearKeepCache = inject('clearKeepCache')
  const userStore = useUserStore()

  const initMount = async () => {
    const userRes = await getUserInfo()
    if (userRes.code === 200) {
      userStore.setUser(userRes.data)
    }
  }

  const clearAllCatch = () => {
    $clearKeepCache && ($clearKeepCache as Function)()
  }

  const logout = async () => {
    const response = await _fetch('/aigc/api/auth/logout', {
      method: 'POST',
      body: JSON.stringify({})
    })
    const res = await response.json()
    if (res.code === 200) {
      userStore.clearUser()
      location.href = '/'
    }
  }
  // 管理学生密码
  const managePSW = () => {
    ShowManagePSW.value = true
  }
  const showLogin = () => {
    // 登陆弹窗展现并埋点
    trackUtil.loginShow()
    LoginService({
      type: 'loginEdu',
      onSuccess() {}
    })
  }

  onMounted(async () => {
    initMount()

    const message = messageQueue.receive(EventBusKey.eduHeaderBackBtnVisible)
    if (message) {
      isShowBackBtn.value = message.visible
    }
    emitter.on(EventBusKey.eduHeaderBackBtnVisible, (visible: any) => {
      isShowBackBtn.value = visible
    })
  })

  onUnmounted(() => {
    emitter.off(EventBusKey.eduHeaderBackBtnVisible)
  })

  const handleBack = () => {
    if (isShowBackBtn.value) {
      router.back()
    }
  }
</script>
<template>
  <header class="header main-container" :class="{ transparent: headerTransparent }">
    <section class="header-container">
      <div class="logo" @click="handleBack">
        <router-link to="/" @click="clearAllCatch" v-if="!isShowBackBtn">
          <img alt="造好物" class="logo" src="@/assets/images/logo-cn.webp" height="30" />
        </router-link>
        <span class="hitems-Frame" v-if="isShowBackBtn"></span>
        <span class="logo-text" :class="{ noTop: isShowBackBtn }">
          {{ isShowBackBtn ? '返回教育公益版' : '教育公益版' }}
        </span>
      </div>
      <nav class="nav"></nav>
      <div class="user-btns">
        <a class="user tooltip-btn">
          <img
            v-if="userStore.getUser.avatar"
            alt="User"
            class="user-icon"
            :src="userStore.getUser.avatar"
            width="40"
            height="40"
          />
          <span v-else @click="showLogin" class="user-btn-item">登录</span>
          <span
            v-if="!userStore.getUser.avatar"
            class="tooltip-msg ticket-tooltip account-tooltip"
          ></span>
          <div v-else class="menu-dropdown">
            <div class="menu-dropdown-content">
              <a
                v-if="userStore.getUser.eduIdentity === 'teacher'"
                class="menu-dropdown-item"
                @click.stop="managePSW"
              >
                <span class="menu-dropdown-icon hitems-notification-status1"></span>
                {{ '管理学生密码' }}
              </a>
              <a class="menu-dropdown-item" @click.stop="logout">
                <span class="menu-dropdown-icon hitems-logout1"></span>
                {{ $t('appHeader.log_out') }}
              </a>
            </div>
          </div>
        </a>
      </div>
    </section>
  </header>
  <TechManagePSW :show="ShowManagePSW" @update:show="ShowManagePSW = $event" />
</template>
<style lang="stylus" scoped>
  @import url('./AppHeaderEdu.styl');
</style>
